import { isSquareTradeAddOn } from '../../common/utils/addOnUtils.js';
import { userHasEmptyOrSMEPriceGroup } from '../../common/utils/employeeUtils.js';
import type { ShoppingCartItemForCheckout } from '../../common/types/checkout.js';
import type { AuthenticatedUser } from '../../public/site/authState';
import type { ActionsHistory } from '../../selfservice/common/store.js';

export function hasCartForbiddenSquareTradeAddOn(
  cartItems: ShoppingCartItemForCheckout[],
  user?: AuthenticatedUser & ActionsHistory
): boolean {
  if (userHasEmptyOrSMEPriceGroup(user?.segmentPricingGroup)) {
    return false;
  }

  return cartItems?.some(ci => ci.selectedAddOns?.some(isSquareTradeAddOn) ?? false) ?? false;
}
